'use server';

import { SessionService } from '@/contexts/authentication';
import type { Character } from '../types';

export async function getCharacter(characterId: string): Promise<Character | null> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return null;

  const { getCharacterRepository } = await import('@/contexts/characters/repositories');
  const character = await getCharacterRepository().getById(characterId);
  if (!character) return null;
  if (character.familyId !== familyId) return null;

  return character as Character;
}
